import React, { memo, useCallback, useEffect, useState } from "react";
import styles from "./ProviderDashboard.module.scss";
import ProviderDashboardCards from "./components/ProviderDashboardCards/ProviderDashboardCards";
import ProductCard from "../components/ProductCard";
import CommonDateRangePicker from "../../../common/components/date-range-picker/CommonDateRangePicker";

import { Range } from "react-date-range";
import TabSelector from "../../../common/components/tab-selector/TabSelector";
import { SolarProduct } from "../../../model/solar-product/solar-product";
import solarProductService from "../../../httpService/SolarProductService";
import { toast } from "react-toastify";
import { ProviderDashboardData } from "../../../model/provider/provider-dashboard-data";
import solarProviderService from "../../../httpService/SolarProviderService";
import CommonLoadingSpinnerForPage from "../../../common/components/loading-spinner/CommonLoadingSpinnerForPage";
import MostRecentOrderTab from "./components/MostRecentOrderTab/MostRecentOrderTab";
import { useDispatch } from "react-redux";
import { updateUsername } from "../../../stores/slices/current-user-slice";

type Props = {};

const ProviderDashboard: React.FC<Props> = memo((props: Props) => {
	const dispatch = useDispatch();
	const [selectedTab, setSelectedTab] = useState(1);

	const date = new Date();
	const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
	const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

	const [loadingProducts, setLoadingProducts] = useState(false);

	const [products, setProducts] = useState<SolarProduct[]>([]);
	const [dashboardData, setDashboardData] = useState<ProviderDashboardData>();
	const [range, setRange] = useState<Range>({
		startDate: firstDay,
		endDate: lastDay,
		key: "selection",
		showDateDisplay: false,
	});

	const currentPage = 1;
	const pageSize = 6;

	const fetchProducts = useCallback(async () => {
		try {
			let productsMapped: SolarProduct[] = [];

			setLoadingProducts(true);

			const response = await solarProductService.getPaged(currentPage, pageSize);

			response.data.items.map((item: any) =>
				productsMapped.push(
					new SolarProduct({
						...item,
					})
				)
			);

			setProducts(productsMapped);
		} catch (error) {
			toast.error("There was an error fetching products");
		} finally {
			setLoadingProducts(false);
		}
	}, [currentPage]);

	const fetchDashboardData = useCallback(async () => {
		try {
			const response = await solarProviderService.getDashboardData(range.startDate!, range.endDate!);

			const data = response.data;

			dispatch(updateUsername({ userName: data.companyName}));

			setDashboardData(data);
		} catch (error) {
			toast.error("There was an error dashboard data");
		}
	}, [range]);

	const handleDateRangeChange = (range: Range) => {
		if (range.startDate && range.endDate) {
			if (range.startDate.getTime() === range.endDate.getTime()) return;
			setRange(range);
		}
	};

	useEffect(() => {
		fetchProducts();
	}, [fetchProducts]);

	useEffect(() => {
		fetchDashboardData();
	}, [fetchDashboardData]);

	const changeTab = (tabId: number) => {
		setSelectedTab(tabId);
	};

	const tabs = [
		{ id: 1, title: "Top Performing Product", onClick: () => changeTab(1) },
		{ id: 2, title: "Most Recent Order", onClick: () => changeTab(2) },
	];

	const renderTabContent = () => {
		switch (selectedTab) {
			case 1:
				return (
					<CommonLoadingSpinnerForPage loading={loadingProducts}>
						<div className={styles.productsCardsContainer}>
							{products.map((product: SolarProduct, index: number) => {
								return <ProductCard key={product.id} product={product} />;
							})}
						</div>
					</CommonLoadingSpinnerForPage>
				);
			case 2:
				return <MostRecentOrderTab startDate={range.startDate!} endDate={range.endDate} />;
		}
	};

	return (
		<>
			<div className={styles.headerSection}>
				<div className={styles.text}>
					General Overview
					<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M2.00004 16L0.583374 14.5833L7.16671 8L0.583374 1.41667L2.00004 0L10 8L2.00004 16Z" fill="#526069" />
					</svg>
				</div>
				<CommonDateRangePicker initialDateRange={range} onChange={handleDateRangeChange} />
			</div>
			{/* <div className={styles.welcomeSection}>
				<b>Welcome,</b> {dashboardData?.companyName}
			</div> */}
			<div className={styles.cardsContainer}>
				<ProviderDashboardCards dashboardData={dashboardData} />
			</div>
			<div className={styles.tabsContainer}>
				<TabSelector tabs={tabs} selectedTab={selectedTab} />
			</div>
			{renderTabContent()}
		</>
	);
});

export default ProviderDashboard;
